window.isInitialCatalogCalled = false
const CallGetLimitApi = async ({amountLimit, originationIsoCode, fundsOutCode, payIn,destinationIsoCode, limitAttribute, country, language}) => {
    // check or catalog api called
    if (window.isInitialCatalogCalled === false) return
    // If amountLimit is not null and is a number, do not call the API and return
    if (!(amountLimit == null || isNaN(parseFloat(amountLimit)))) return
    sessionStorage.removeItem(`getLimitsApiResponse-${destinationIsoCode}`);
    const isR4Country = getR4Country();
    const serviceCode = CloudPayOutCodeMapping[fundsOutCode?.toUpperCase()] || '';
    const payInCode = CloudPayIn[payIn?.toUpperCase()] || '';
    if(isR4Country)  {
        await getlimitAPIR4(originationIsoCode, destinationIsoCode, serviceCode, payInCode, limitAttribute, country?.toUpperCase(), language)
    } else {
        await getlimitAPI(originationIsoCode, destinationIsoCode, serviceCode, payInCode, limitAttribute, country?.toUpperCase(), language)
    }
}